import $ from 'jquery';
import { getParams } from '@frontend/util/url';

const initCustomTracking = () => {
  const { digitalData, _satellite } = window;
  if (digitalData && _satellite) {
    $(document.body).on('mousedown', '#findSolution', (evt) => {
      const btn = $(evt.currentTarget);
      const parts = [];
      btn.closest('.solutionfinder-form').find('[data-selectedvalue]').each((index, el) => {
        parts.push($(el).attr('data-selectedvalue'));
      });
      digitalData.actions = {
        item: 'findsolutions',
        value: parts.join('|')
      };
      // eslint-disable-next-line no-underscore-dangle
      _satellite.track('actiontracking');
      console.debug(digitalData.actions);
    });
  }
};

const setupSolutionsFinder = () => {
  const toggleFinderButton = () => {
    const dropdowns = $('.solutionfinder-form .dropdown-update');
    const selectedDropdowns = Array.from(dropdowns).filter((element) => {
      element = $(element);
      const selectedValue = element.attr('data-selectedvalue');
      const defaultValue = element.attr('data-defaultvalue') || 'Select';
      return selectedValue && selectedValue !== defaultValue;
      // TODO: find a better way for when there are other languages
    });
    const enabled = (dropdowns.length === selectedDropdowns.length);
    $('#findSolution').toggleClass('disabled', !enabled);
    $('#form-fields').toggleClass('d-none', !enabled);
  };

  toggleFinderButton();
  $('.dropdown-update .dropdown-item').on('click', (evt) => {
    const $this = $(evt.currentTarget);
    const text = $this.text();
    const value = $this.attr('data-value');
    const id = $this.attr('data-id') || '';

    $this.closest('.dropdown-update')
      .attr('data-selectedvalue', value)
      .find('.dropdown-link').text(text)
      .attr({
        title: text,
        'data-id': id
      });

    toggleFinderButton();
  });
};

const initFilterSolutions = () => {
  if ($('#findSolution').length && !$('#findSolution').hasClass('disabled')) {
    const locale = $('#solution-basedIn').text().trim().toLowerCase();
    const groupsize = $('#solution-insuranceGroup').text().trim().toLowerCase();
    const duration = $('#solution-duration').text().trim().toLowerCase();
    const noFilter = [...new Set([location, groupsize, duration])];
    $('#solution-response').removeClass('no-solution-found');
    $('.no-solution').hide();
    if (noFilter.length <= 1) {
      $('.single-solution').show();
    } else {
      $('.single-solution').each((i, el) => {
        el = $(el);
        const locales = [...el.attr('data-location').toLowerCase().split(', '), 'all'];
        const groupsizes = [...el.attr('data-coverage').toLowerCase().split(', '), 'all'];
        const durations = [...el.attr('data-duration').toLowerCase().split(', '), 'all'];
        if (locales.includes(locale) &&
            groupsizes.includes(groupsize) &&
            durations.includes(duration)) {
          el.show();
        }
      });
    }
    if ($('.single-solution:visible').length === 0) {
      $('#solution-response').addClass('no-solution-found');
      $('.no-solution').show();
    }
  }
};

const toggleFormFields = () => {
  $('li.question').on('click', 'button.dropdown-item', (evt) => {
    const item = $(evt.currentTarget).closest('ul').data('name');
    const temp = $(evt.currentTarget).data('value');
    $(`#${item}`).val(temp);
  });
};

const initUpdateRegion = () => {
  const params = getParams(location.search);
  if (params.country && [...$('.selected-region .dropdown-item:not(.disabled)')].map(e => $(e).attr('data-value')).some(e => (params.country.includes(e)))) {
    const regionSelected = params.country;
    $('.selected-region').attr('data-selectedvalue', regionSelected);
    $('.region-shown').text(regionSelected);
    $('#company-based').val(regionSelected);
  }
};

export default () => {
  setupSolutionsFinder();
  initCustomTracking();
  initFilterSolutions();
  toggleFormFields();
  initUpdateRegion();

  $('#findSolution').on('click', (e) => {
    e.preventDefault();
    const isFilter = $('.single-solution');
    const isRegionRedirect = $('#solution-region');
    const isIgoNgo = $('#solution-organization');
    switch (true) {
      case isFilter.length >= 1: {
        $('.single-solution').hide();
        initFilterSolutions();
        break;
      }
      case isRegionRedirect.length >= 1: {
        const regionClicked = $(`button[data-value='${isRegionRedirect.text()}']`);
        const regionPath = regionClicked.attr('href');
        const regionTarget = regionClicked.attr('target') ? regionClicked.attr('target') : '_self';
        window.open(regionPath, regionTarget);
        break;
      }
      case isIgoNgo.length >= 1: {
        const organizationType = $('#solution-organization').text();
        const organizationId = $('#solution-organization').attr('data-id');
        if (organizationType === 'Intergovernmental organization (IGO)') {
          location.assign($("button[data-value='Intergovernmental organization (IGO)']").attr('href'));
        } else if (organizationId === 'IGO') {
          location.assign($("button[data-id='IGO']").attr('href'));
        } else {
          const coverageType = $('#solution-coverage').text();
          location.assign($(`button[data-value='${coverageType}']`).attr('href'));
        }
        break;
      }
      default: {
        break;
      }
    }
  });

  $('.igo-solution-menu button').on('click', (e) => {
    e.preventDefault();
    const organizationType = $('#solution-organization').text();
    const igoSolutionMenu = $('.dropdown-menu.igo-solution-menu li button');
    // eslint-disable-next-line array-callback-return
    [...igoSolutionMenu].filter((elem, i) => {
      if (i === 1 && $(elem).text() === organizationType) {
        $('#findSolution').removeClass('disabled');
        $('.coverage-holder').hide();
      } else if (i === 2 && $(elem).text() === organizationType) {
        $('.coverage-holder').show();
      } else {
        $('.coverage-holder').hide();
      }
    });
  });
};



// WEBPACK FOOTER //
// ./src/static/js/solutions.js